import React from "react";
import { GithubPicker } from "react-color";

import { ListItemIcon, ListItemText, ListItemButton } from "@mui/material";
import IconColorLens from "@mui/icons-material/ColorLens";
import Dropdown from "../../Dropdown";

function Toggle() {
  return (
    <ListItemButton>
      <ListItemIcon>
        <IconColorLens />
      </ListItemIcon>
      <ListItemText>Bubble color</ListItemText>
    </ListItemButton>
  );
}

const Picker = React.forwardRef(({ colorHandler }, ref) => (
  <div style={{ boxSizing: "content-box" }} ref={ref}>
    <GithubPicker onChange={colorHandler} />
  </div>
));

export default Dropdown(Toggle, Picker);
